export type DepreciationMethod = 'SLN' | 'DB' | 'SYD' | 'DDB'

export const METHOD_LABEL: Record<DepreciationMethod, string> = {
  SLN: 'Straight-line (SLN)',
  DB: 'Declining balance (DB)',
  SYD: 'Sum-of-years-digits (SYD)',
  DDB: 'Double declining balance (DDB)',
}

export const ASSET_CATEGORIES = [
  'Land & Buildings',
  'Machinery & Equipment',
  'Vehicles',
  'Furniture & Fixtures',
  'Computer Equipment',
  'Leasehold Improvements',
  'Other',
] as const

export type ScheduleParams = {
  method: DepreciationMethod
  useful_life_years: number
  residual_value_percent: number
}

export type Schedule = {
  id: number
  schedule_type: string
  description: string | null
  category: string | null
  initial_amount: number | string
  start_date: string | null
  purchase_date: string | null
  duration_periods: number | null
  params?: ScheduleParams | null
  debit_account?: string | null
  credit_account?: string | null
  third_account?: string | null
  status: string
}

export type ScheduleEntry = {
  period_number: number
  entry_date: string
  amount: number
  secondary_amount?: number
  balance: number
  accumulated: number
  posted?: boolean
}

export type ScheduleDetailResponse = {
  schedule: Schedule
  entries: ScheduleEntry[]
}

export type CreateSchedulePayload = {
  schedule_type: 'depreciation'
  description: string
  category: string
  initial_amount: number
  start_date: string
  purchase_date: string | null
  duration_periods: number
  params: ScheduleParams
  debit_account: string
  credit_account: string
  third_account: string | null
  entries: ScheduleEntry[]
}
